import { useLenisStore } from '~/stores/LenisStore'

export default function () {
  const store = useLenisStore()
  const isLocked = useState('bodyLock')

  function bodyLock() {
    if (store.lenis) {
      store.lenis.stop()
      isLocked.value = true
      document.body.classList.add('overflow-hidden')
    }
  }

  function bodyUnlock() {
    if (store.lenis) {
      store.lenis.start()
      document.body.classList.remove('overflow-hidden')
      isLocked.value = false
    }
  }

  return {
    bodyLock,
    bodyUnlock
  }
}
